module.exports = __webpack_public_path__ + "static/img/voice0_left.0bdce8e6.png";